/**
 * Crixus, Gaul-Breaker — Champion
 *
 * Effects:
 *   1. On the 3rd attack you play in a round, draw 1 card.
 *   2. Each time you deal damage with an attack, queue +1 power on your
 *      next attack.
 *
 * NOTE: Crixus is a Champion card, so its hooks live in CHAMPION_REGISTRY,
 * NOT the regular REGISTRY. They are invoked from playAttackDefend
 * (onAttackPlay) and resolveCombat (onDamageDealt) via getChampionHooksFor.
 */
import { makeBuff } from "../playtestEngine";
import type { ChampionHooks } from "./registry";

export const crixusGaulBreaker: ChampionHooks = {
  onAttackPlay: (ctx) => {
    // `ctx.self.attacksThisRound` is the per-player counter (reset every
    // round in beginRound). It is incremented BEFORE this hook fires in
    // playAttackDefend, so on the 3rd attack of the round it reads 3.
    if (ctx.self.attacksThisRound === 3) {
      return {
        drawSelf: 1,
        log: ["Crixus, Gaul-Breaker — 3rd attack this round draws a card."],
      };
    }
    return {};
  },

  onDamageDealt: (ctx) => {
    if (!ctx.damageDealt || ctx.damageDealt <= 0) return {};
    return {
      queueSelfBuff: makeBuff(
        "Crixus, Gaul-Breaker",
        "next-attack",
        { kind: "power-bonus", amount: 1 },
        ctx.game.round,
      ),
      log: ["Crixus, Gaul-Breaker — next attack gets +1 power."],
    };
  },
};
